import { OrderPayableBy, OrderPayableTo } from "../../../../views/Orders/enums";

export const isInvalidPaymentRouteCombination = (
  payableBy: OrderPayableBy | "",
  payableTo: OrderPayableTo | "",
): boolean =>
  (payableBy === OrderPayableBy.INSURANCE ||
    payableBy === OrderPayableBy.NBFC) &&
  payableTo === OrderPayableTo.SUPPLIER;
